/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-10-10 12:00:50
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-10-20 10:50:48
 * @FilePath: /wemeet-web-activity/src/constant/ticket-pay-status.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export let FREE = /*#__PURE__*/function (FREE) {
  FREE[FREE["NOT_PAY"] = 0] = "NOT_PAY";
  FREE[FREE["PAY_SUCC"] = 1] = "PAY_SUCC";
  FREE[FREE["PAY_ERR"] = 2] = "PAY_ERR";
  FREE[FREE["APPROVAL"] = 3] = "APPROVAL";
  FREE[FREE["LOADING"] = 4] = "LOADING";
  return FREE;
}({});
export let PAYSTATUS = /*#__PURE__*/function (PAYSTATUS) {
  PAYSTATUS[PAYSTATUS["NOT_PAY"] = 0] = "NOT_PAY";
  PAYSTATUS[PAYSTATUS["PAY_SUCC"] = 1] = "PAY_SUCC";
  PAYSTATUS[PAYSTATUS["PAY_ERR"] = 2] = "PAY_ERR";
  return PAYSTATUS;
}({});